import React, { Fragment } from 'react';

import PortfolioSnapshot from 'components/layouts/Snapshot/PortfolioSnapshot';
import WorkplaceRetirementSnapshot from 'components/layouts/Snapshot/WorkplaceRetirementSnapshot';
import RetailTracSnapshot from 'components/layouts/Snapshot/RetailTracSnapshot';
import { connect } from 'react-redux';
import { getHasRetailTracAccounts, getHasWorkPlaceRetirementAccounts } from 'state/account/AccountSelectors';

function ActiveAdvisoryDashboardMain({ view, hasWorkplaceRetirementAccounts, hasRetailTracAccounts }) {
    const { hasCollegeSavingsOnly } = view;


  return (
    <Fragment>
      <PortfolioSnapshot />

      {!hasCollegeSavingsOnly && hasWorkplaceRetirementAccounts && (
        <WorkplaceRetirementSnapshot />
        )}
        {hasRetailTracAccounts &&
            <RetailTracSnapshot />
        }
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
    hasWorkplaceRetirementAccounts: getHasWorkPlaceRetirementAccounts(state),
    hasRetailTracAccounts: getHasRetailTracAccounts(state),

});

export default connect(mapStateToProps)(ActiveAdvisoryDashboardMain)
